<script>
    import {onMount, createEventDispatcher} from "svelte"
    import {files, api}from "../../store"
    import UpdateImage from "./UpdateImage.svelte";
    export let reload = 0
    let file, api_url
    files.subscribe((value) => {
        file = value
    })
    api.subscribe((value) => {
        api_url = value
    })
    
    let data = []
    let loading = true;
    let dispatch = createEventDispatcher()
    
$: reload>=0? getData():null


    function getData() {
        loading = true;
        let sendData = new FormData()
        let loginDatum = JSON.parse(localStorage.getItem('loginData'))
        sendData.append("get",  "true")
        sendData.append('master', loginDatum.email)
        fetch(`${api_url}matrimonial.php`, {
            method: "POST",
            body:sendData
        })
        .then(res => res.json())
        .then(res => {
        data = res.data;
        })
        .finally(()=>{loading = false})
    }


function operation(action, id){
    loading = true;
    let sendData = new FormData()
    let loginDatum = JSON.parse(localStorage.getItem('loginData'))
    sendData.append(action,  "true")
    sendData.append("id",  id)
    sendData.append('master', loginDatum.email)
    fetch(`${api_url}matrimonial.php`, {
        method: "POST",
        body:sendData
    })
    .then(res => res.json())
    .then(res => {
        if (!res.error) {
            getData()
        }else {
            alert("Somthing went wrong");
        }
    })
    .finally(()=>{loading = false})
}

onMount(()=>getData())
</script>

{#if reload >=0}
{#if Array.isArray(data) && data.length > 0 }
<div class="ds-form-title text-center p-5" style="margin-top: 10vh;">
    <h1>My Matrimonial Registrations </h1>
    <p class="text-danger">By clicking the delete your data will be removed</p>
    <p class="text-success">By clicking the close, we would assume the bride/groom had their weddings successfully</p>
 </div>
 {/if}
<div class="ds-cards-collection" style="margin-bottom: 10vh;">
    
    {#if Array.isArray(data) && data.length > 0 }

    {#each data as datum }
    <div class="card" style="width: 18rem;">
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img class="card-img-top" src={`${file}${datum.photo}`} alt="Card image cap">
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img class="card-img-top" src={`${file}${datum.horoscope}`} alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">{datum.full_name}</h5>
        
          <button on:click={()=>dispatch("edit",{data: datum})} class="btn btn-primary">Edit</button>
          <button on:click={()=>operation("delete", datum.id)} class="btn btn-danger">Delete</button>
          <button on:click={()=>operation("close", datum.id)} class="btn btn-success">Close</button>
          <UpdateImage action="updatephoto" field="photo" id={datum.id} on:updated={()=>getData()}/>
          <UpdateImage action="updatehoroscope" field="horoscope" id={datum.id} on:updated={()=>getData()}/>
        </div>
      </div>
    {/each}

    {:else}
    {#if loading}
    <div class="loading">
        <h1>Fetching....</h1>
    </div>
    {:else}
    <div class="loading">
        <h1>No Records Found</h1>
    </div>
    {/if}

    
        
    {/if}
    
</div>
{/if}



<style lang="scss">

    .ds-cards-collection {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        flex-wrap: wrap;
    }

    .loading {
        height: 70vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
